import { TooltipParagraph } from "components/tooltipParagraph";
import { abbreviateNumbers, currencySymbol, formatNumber } from "utills/helpers";

export interface IAddonSales {
  addon_id: string;
  variant_id: string;
  addon_name: string;
  variant_label: string;
  unit_price: number;
  quantity: number;
  gross_revenue: number;
}

interface AddonsTableProps {
  data?: IAddonSales[];
  pageSize: number;
  currentPage: number;
  isLoading: boolean;
  currency?: string;
}

export const AddonsTable = ({
  data = [],
  isLoading,
  currentPage = 1,
  pageSize = 10,
  currency,
}: AddonsTableProps) => {
  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                No
              </th>
              <th scope="col" className="th">
                Addon name
              </th>
              <th scope="col" className="th">
                Variant
              </th>
              <th scope="col" className="th">
                Quantity
              </th>
              <th scope="col" className="th">
                Unit price
              </th>
              <th scope="col" className="th">
                Gross revenue
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {!isLoading
              ? data.map((item: IAddonSales, index: number) => (
                  <tr key={index}>
                    <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                      {(currentPage - 1) * pageSize + 1 + index}
                    </td>
                    <td className="td max-w-10 overflow-x-auto">
                      <TooltipParagraph
                        text={item.addon_name || "-"}
                        className="whitespace-pre-wrap max-w-[280px]"
                      />
                    </td>
                    <td className="td overflow-x-auto">
                      {item.variant_label || "-"}
                    </td>
                    <td className="td overflow-x-auto">
                      <span
                        data-tooltip-id="tooltip"
                        data-tooltip-content={formatNumber(item.quantity ?? 0)}
                      >
                        {abbreviateNumbers(item.quantity ?? 0)}
                      </span>
                    </td>
                    <td className="td overflow-x-auto">
                      <span
                        data-tooltip-id="tooltip"
                        data-tooltip-content={formatNumber(item.unit_price ?? 0)}
                      >
                        {currencySymbol(currency)} {abbreviateNumbers(item.unit_price ?? 0)}
                      </span>
                    </td>
                    <td className="td overflow-x-auto">
                      <span
                        data-tooltip-id="tooltip"
                        data-tooltip-content={formatNumber(item.gross_revenue ?? 0)}
                      >
                        {currencySymbol(currency)} {abbreviateNumbers(item.gross_revenue ?? 0)}
                      </span>
                    </td>
                  </tr>
                ))
              : [...Array(10).keys()].map((index: number) => (
                    <tr key={index} className="h-[57px]">
                      <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                        <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                      </td>
                      <td className="td max-w-40 overflow-x-auto">
                        <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                      </td>
                      <td className="td">
                        <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                      </td>
                      <td className="td">
                        <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                      </td>
                      <td className="td">
                        <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                      </td>
                      <td className="td">
                        <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                      </td>
                    </tr>
                  ))}
            {data.length === 0 && !isLoading ? (
              <tr>
                <td colSpan={6} className="td">
                  <div className="text-center">No data</div>
                </td>
              </tr>
            ) : <></>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
